var h = Object.defineProperty;
var u = (n, e, t) => e in n ? h(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var a = (n, e, t) => u(n, typeof e != "symbol" ? e + "" : e, t);
import { guidesApiRootPath as i } from "../guide/client.mjs";
const r = "default";
class o {
  constructor(e) {
    a(this, "instance");
    this.instance = e;
  }
  async get() {
    this.instance.failIfNotAuthenticated();
    const e = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}`
    });
    return this.handleResponse(e);
  }
  async identify(e = {}) {
    this.instance.failIfNotAuthenticated();
    const t = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}`,
      params: e
    });
    return this.handleResponse(t);
  }
  async getAllPreferences() {
    this.instance.failIfNotAuthenticated();
    const e = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences`
    });
    return this.handleResponse(e);
  }
  async getPreferences(e = {}) {
    this.instance.failIfNotAuthenticated();
    const t = e.preferenceSet || r, s = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences/${t}`,
      params: { tenant: e.tenant }
    });
    return this.handleResponse(s);
  }
  async setPreferences(e, t = {}) {
    this.instance.failIfNotAuthenticated();
    const s = t.preferenceSet || r, c = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${s}`,
      data: e
    });
    return this.handleResponse(c);
  }
  async getChannelData(e) {
    this.instance.failIfNotAuthenticated();
    const t = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/channel_data/${e.channelId}`
    });
    return this.handleResponse(t);
  }
  async setChannelData({
    channelId: e,
    channelData: t
  }) {
    this.instance.failIfNotAuthenticated();
    const s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/channel_data/${e}`,
      data: { data: t }
    });
    return this.handleResponse(s);
  }
  async getGuides(e, t) {
    const s = await this.instance.client().makeRequest({
      method: "GET",
      url: `${i(this.instance.userId)}/${e}`,
      params: t
    });
    return this.handleResponse(s);
  }
  async markGuideStepAs(e, t) {
    const s = await this.instance.client().makeRequest({
      method: "PUT",
      url: `${i(this.instance.userId)}/messages/${t.message_id}/${e}`,
      data: t
    });
    return this.handleResponse(s);
  }
  handleResponse(e) {
    if (e.statusCode === "error")
      throw new Error(e.error || e.body);
    return e.body;
  }
}
export {
  o as default
};
//# sourceMappingURL=index.mjs.map
